// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YJfoj","title":"styles_title__aChWS"};